// Dependencies
import React, { Component } from 'react';
import { isMobileOnly } from 'react-device-detect';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Primereact imports
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';

// Styling
import './other-post-grad-data.scss';

// Utils
import { DOC_TYPE_CERT_EQUIV_NON_FISIO, DOC_TYPE_CERT_HAB_NON_FISIO, OTHER_POST_GRADS } from '../../../../common/constants';
import { WORLD_LIST } from '../../../../common/lists/countries';
import { getOtherPostGradList } from '../../../../common/lists/qualification';
import { formatQualificationOtherPostGradDataFormValues } from '../../../../common/formatters/qualification-other-post-grad-data';
import { convertBase64ToArrayBuffer, downloadFile } from '../../../../common/utils/download-utils';
import { getRegistrationDoc } from '../../../../common/utils/registration-utils';
import { formatAssociateDataToService } from '../../../../common/formatters/associate';
import { getYesNoDropdownList } from '../../../../common/utils/form-data-utils';

// Redux
import { connect } from 'react-redux';
import DocumentService from '../../../../redux/services/document';
import { getAssociateData, setEditMode } from '../../../../redux/actions/profile';
import ProfileService from '../../../../redux/services/profile';

class OtherPostGradDataComponent extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            associate: null,
            readOnlyMode: true,
            addTrainingMode: false,
            // Cursor variables
            cursorDegree: null,
            cursorTrainingTitle: "",
            cursorTrainingArea: "",
            cursorEndDate: null,
            cursorTrainingSchool: "",
            cursorTrainingCountry: null,
            cursorAcceptanceSchool: "",
            cursorAcceptanceDate: null,
            certHabAttachment: null,
            certEquivAttachment: null,
            certHabAttachmentName: "",
            certEquivAttachmentName: "",
            // Mandatory fields validation
            validDegree: true,
            validDegreeTitle: true,
            validEndDate: true,
            validSchoolCountry: true,
            validTrainingSchool: true,
            validCertHabFile: true,
            validUploadFile: true
        };
    }

    componentDidMount() {
        this.setState({
            associate: this.props.associate
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language) {
            let associate = this.props.associate;
            
            this.setState({
                associate: formatQualificationOtherPostGradDataFormValues(associate, this.props.language)
            });
        }
    }

    activateEditMode() {
        this.setState({
            readOnlyMode: false,
            addTrainingMode: false
        });

        this.props.setEditMode(true);
    }

    cancelEditMode() {
        this.clearComponentVariables();
        this.props.setEditMode(false);
    }

    validateForm() {
        let validationResult = true;
        
        this.setState({
            validDegree: this.state.cursorDegree !== null,
            validDegreeTitle: this.state.cursorTrainingTitle !== "",
            validEndDate: this.state.cursorEndDate !== null,
            validTrainingSchool: this.state.cursorTrainingSchool !== "",
            validSchoolCountry: this.state.cursorTrainingCountry !== null,
            validCertHabFile: this.state.certHabAttachment !== null
        });

        validationResult = (this.state.cursorDegree !== null &&
                            this.state.cursorTrainingTitle !== "" &&
                            this.state.cursorEndDate !== null &&
                            this.state.cursorTrainingSchool !== "" &&
                            this.state.cursorTrainingCountry !== null &&
                            this.state.certHabAttachment !== null);

        return validationResult;
    }

    saveChanges() {
        let associate = this.state.associate;

        if(this.state.addTrainingMode === true) {
            if(this.validateForm()) { 
                associate.otherPostGrads.push({
                    degreeLevel: this.state.cursorDegree,
                    trainingTitle: this.state.cursorTrainingTitle,
                    trainingArea: this.state.cursorTrainingArea,
                    endDate: this.state.cursorEndDate,
                    trainingSchool: this.state.cursorTrainingSchool,
                    trainingCountry: this.state.cursorTrainingCountry,
                    acceptanceSchool: this.state.cursorAcceptanceSchool,
                    acceptanceDate: this.state.cursorAcceptanceDate
                });

                ProfileService.updateAssociateData(formatAssociateDataToService(associate), this.props.t('general.update-record'), OTHER_POST_GRADS)
                .then((response) => {

                    // Upload cert hab file
                    ProfileService.uploadAssociateDocument(this.state.certHabAttachment, this.props.registrationRef.toString(), DOC_TYPE_CERT_HAB_NON_FISIO[this.state.associate.otherPostGrads.length - 1])
                    .then((response) => {

                        if(this.state.certEquivAttachment !== null) {
                            // Upload cert equiv file
                            ProfileService.uploadAssociateDocument(this.state.certEquivAttachment, this.props.registrationRef.toString(), DOC_TYPE_CERT_EQUIV_NON_FISIO[this.state.associate.otherPostGrads.length - 1])
                            .then((response) => {
                                this.props.getAssociateData(this.props.registrationRef);

                                setTimeout(() => {
                                    this.setState({
                                        associate: this.props.associate
                                    });
                                }, 1500);
                            })
                            .catch(error => {
                                this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
                            });
                        }
                        else {
                            this.props.getAssociateData(this.props.registrationRef);

                            setTimeout(() => {
                                this.setState({
                                    associate: this.props.associate
                                });
                            }, 1500);
                        }
                    })
                    .catch(error => {
                        this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
                    });

                    this.setState({
                        associate: associate,
                        readOnlyMode: true,
                        addTrainingMode: false,
                        cursorDegree: null,
                        cursorTrainingTitle: "",
                        cursorEndDate: null,
                        cursorTrainingSchool: "",
                        cursorTrainingCountry: null,
                        cursorAcceptanceSchool: "",
                        cursorAcceptanceDate: null,
                        validDegree: true,
                        validDegreeTitle: true,
                        validEndDate: true,
                        validSchoolCountry: true,
                        validTrainingSchool: true
                    });
    
                    this.props.setEditMode(false);
                })
                .catch(error => {
                    this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
                });
            }
        }
        else {
            this.clearComponentVariables();
            this.props.setEditMode(false);
        }
    }

    clearComponentVariables() {
        this.setState({
            associate: formatQualificationOtherPostGradDataFormValues(this.props.associate, this.props.language),
            readOnlyMode: true,
            addTrainingMode: false,
            cursorDegree: null,
            cursorTrainingTitle: "",
            cursorEndDate: null,
            cursorTrainingSchool: "",
            cursorTrainingCountry: null,
            cursorAcceptanceSchool: "",
            cursorAcceptanceDate: null,
            validDegree: true,
            validDegreeTitle: true,
            validEndDate: true,
            validSchoolCountry: true,
            validTrainingSchool: true,
            certEquivAttachment: null,
            certHabAttachment: null,
            certEquivAttachmentName: "",
            certHabAttachmentName: "",
            validCertHabFile: true,
            validUploadFile: true
        });
    }

    setTrainingMode() {
        this.setState({
            addTrainingMode: true
        });
    }

    downloadDocument(documentRef) {
        DocumentService.downloadDocument(documentRef)
          .then((response) => {
                var blob = new Blob([convertBase64ToArrayBuffer(response.fileContent)], { type: response.contentType });
                downloadFile(URL.createObjectURL(blob), response.filename);
          })
          .catch(error => {
              this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
          });
    }

    gradHasDocument(documentType) {
        let doc = getRegistrationDoc(this.props.registrationDocs, documentType);
        return doc !== null;
    }

    getGradDocumentRef(documentType) {
        let doc = getRegistrationDoc(this.props.registrationDocs, documentType);
        return doc.nodeRef;
    }

    uploadDocumentHandler(document, documentType) {
        let self = this;
        var reader = new FileReader();
        reader.readAsBinaryString(document[0]);

        reader.onload = function() {
            if(documentType === "cert_hab") {
                self.setState({
                    certHabAttachment: btoa(reader.result),
                    certHabAttachmentName: document[0].name,
                    validUploadFile: true
                });
            }
            else {
                self.setState({
                    certEquivAttachment: btoa(reader.result),
                    certEquivAttachmentName: document[0].name,
                    validUploadFile: true
                });
            }
        };
    }

    render() {
        return (
            this.state.associate !== null && this.state.associate.qualificationData !== null ? 
                <div className='grid'>
                    <Tooltip target=".other-post-grad-data-help-icon" />
                    <div className='col-12'>
                        <div className="card p-fluid mgt-20">
                            <div className='grid'>
                                <div className='col-12 t-align-right'>
                                    {
                                        this.state.readOnlyMode === true ? 
                                            <Button icon="pi pi-pencil" className="p-button-rounded mr-2 mb-2" disabled={!this.props.registrationApproved} onClick={() => this.activateEditMode()} />
                                            :   
                                            <>
                                                <Button icon="pi pi-check" className="p-button-rounded p-button-success mr-2 mb-2" onClick={() => this.saveChanges()} />
                                                <Button icon="pi pi-ban" className="p-button-rounded p-button-danger mr-2 mb-2" onClick={() => this.cancelEditMode()} />
                                            </>
                                    }
                                </div>  
                                <div className='col-12 t-align-left'>
                                    <span>
                                        <b>{this.props.t("profile.areas.qualification.areas.other-post-grad.form-title")}</b>
                                    </span>
                                </div>
                                <div className='col-12 t-align-left'>
                                    <label htmlFor="hasTraining">{this.props.t("profile.areas.qualification.areas.other-post-grad.has-training")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="hasTraining" disabled={true} value={this.state.associate.qualificationData.hasOtherPostGrads} options={getYesNoDropdownList(getLanguage())} optionLabel="name"></Dropdown>
                                </div>
                                {
                                    this.state.associate.otherPostGrads.length > 0 || this.state.readOnlyMode === false ?
                                        <div className='col-12 t-align-left'>
                                            <span>
                                                <b className='mgr-5'>{this.props.t("profile.areas.qualification.areas.other-post-grad.sub-title")}</b>
                                                <i className="other-post-grad-data-help-icon pi pi-question-circle p-text-secondary" data-pr-tooltip={this.props.t("profile.areas.qualification.areas.other-post-grad.help-messages.sub-title")} data-pr-position="right" data-pr-at="right+5 center" data-pr-my="left center-2" style={{ color:"#0073aa", fontSize:"16px", fontWeight:"bold", cursor: 'pointer' }}></i>
                                            </span>
                                        </div>
                                        : null
                                }
                                {
                                    this.state.associate.otherPostGrads.map((grad) => { 
                                        return  <div key={grad.order} className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                    <div className='grid'>
                                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                            <label htmlFor="degree">{this.props.t("profile.areas.qualification.areas.other-post-grad.degree")} <span className="invalid-message">*</span></label>
                                                            <Dropdown id="degree" value={grad.degreeLevel} disabled={true} options={getOtherPostGradList(getLanguage())} optionLabel="name"></Dropdown>
                                                        </div>
                                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                            <label htmlFor="degreeTitle">{this.props.t("profile.areas.qualification.areas.other-post-grad.degree-title")} <span className="invalid-message">*</span></label>
                                                            <InputText id="degreeTitle" value={grad.trainingTitle} disabled={true} type="text" />
                                                        </div>
                                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                            <label htmlFor="conclusionDate">{this.props.t("profile.areas.qualification.areas.other-post-grad.conclusion-date")} <span className="invalid-message">*</span></label>
                                                            <Calendar value={grad.endDate} dateFormat="dd/mm/yy" maxDate={new Date()} disabled={true} showIcon showButtonBar />
                                                        </div>
                                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                            <label htmlFor="school">{this.props.t("profile.areas.qualification.areas.other-post-grad.school")} <span className="invalid-message">*</span></label>
                                                            <InputText id="school" value={grad.trainingSchool} disabled={true} type="text" />
                                                        </div>
                                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                            <label htmlFor="schoolCountry">{this.props.t("profile.areas.qualification.areas.other-post-grad.school-country")} <span className="invalid-message">*</span></label>
                                                            <Dropdown id="schoolCountry" value={grad.trainingCountry} disabled={true} options={WORLD_LIST} optionLabel="name"></Dropdown>
                                                        </div>
                                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                            <label htmlFor="trainingArea">{this.props.t("profile.areas.qualification.areas.other-post-grad.training-area")}</label>
                                                            <InputText id="trainingArea" value={grad.trainingArea} disabled={true} type="text" />
                                                        </div>
                                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                            <label htmlFor="recognitionSchool">{this.props.t("profile.areas.qualification.areas.other-post-grad.recognition-school")} </label>
                                                            <InputText id="recognitionSchool" value={grad.acceptanceSchool} disabled={true} type="text" />
                                                        </div>
                                                        <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                            <label htmlFor="recognitionDate">{this.props.t("profile.areas.qualification.areas.other-post-grad.recognition-date")} </label>
                                                            <Calendar value={grad.acceptanceDate} dateFormat="dd/mm/yy" maxDate={new Date()} disabled={true} showIcon showButtonBar />
                                                        </div>
                                                        <div className='col-4 t-align-left'>
                    
                                                        </div>
                                                        <div className='col-12'><hr/></div>
                                                        {
                                                        this.gradHasDocument(DOC_TYPE_CERT_HAB_NON_FISIO[grad.order-1]) ?
                                                                <span className={isMobileOnly ? '' : 'mgl-10'} onClick={() => this.downloadDocument(this.getGradDocumentRef(DOC_TYPE_CERT_HAB_NON_FISIO[grad.order-1]))}>
                                                                    <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.qualification.areas.other-post-grad.documents.cert-hab")} icon="pi pi-download" className="mr-2 mb-2" />
                                                                </span>
                                                                : null
                                                        }
                                                        {
                                                        this.gradHasDocument(DOC_TYPE_CERT_EQUIV_NON_FISIO[grad.order-1]) ?
                                                                <span className={isMobileOnly ? '' : 'mgl-10'} onClick={() => this.downloadDocument(this.getGradDocumentRef(DOC_TYPE_CERT_EQUIV_NON_FISIO[grad.order-1]))}>
                                                                    <Chip title={this.props.t("general.download")} style={{color: "#FFFFFF", background:"#0073aa", cursor: 'pointer'}} label={this.props.t("profile.areas.qualification.areas.other-post-grad.documents.cert-equiv")} icon="pi pi-download" className="mr-2 mb-2" />
                                                                </span>
                                                                : null
                                                        }
                                                    </div>
                                                </div>
                                    })
                                }
                                {
                                    !this.state.readOnlyMode && !this.state.addTrainingMode && this.state.associate.otherPostGrads.length < 10 ?
                                        <div className='col-12 t-align-center'>
                                            <Button icon="pi pi-plus" className="mr-2 mb-2" style={{width: "200px"}} onClick={() => this.setTrainingMode()}>
                                                <span className={isMobileOnly ? '' : 'mgl-10'}>{this.props.t("profile.areas.qualification.areas.other-post-grad.add-training")}</span>
                                            </Button>                              
                                        </div>
                                        : null
                                }
                                {
                                    !this.state.readOnlyMode && this.state.addTrainingMode ?
                                        <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                            <div className='grid'>
                                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                    <label htmlFor="editDegree">{this.props.t("profile.areas.qualification.areas.other-post-grad.degree")} <span className="invalid-message">*</span></label>
                                                    <Dropdown id="editDegree" value={this.state.cursorDegree} options={getOtherPostGradList(getLanguage())} optionLabel="name" onChange={(evt) => this.setState({ cursorDegree: evt.value })}></Dropdown>
                                                    { this.state.validDegree ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                    <label htmlFor="editDegreeTitle">{this.props.t("profile.areas.qualification.areas.other-post-grad.degree-title")} <span className="invalid-message">*</span></label>
                                                    <InputText id="editDegreeTitle" value={this.state.cursorTrainingTitle} type="text" onChange={(evt) => this.setState({ cursorTrainingTitle: evt.target.value })}/>
                                                    { this.state.validDegreeTitle ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                    <label htmlFor="editConclusionDate">{this.props.t("profile.areas.qualification.areas.other-post-grad.conclusion-date")} <span className="invalid-message">*</span></label>
                                                    <Calendar value={this.state.cursorEndDate} dateFormat="dd/mm/yy" maxDate={new Date()} showIcon showButtonBar onChange={(evt) => this.setState({ cursorEndDate: evt.value })}/>
                                                    { this.state.validEndDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                    <label htmlFor="editSchool">{this.props.t("profile.areas.qualification.areas.other-post-grad.school")} <span className="invalid-message">*</span></label>
                                                    <InputText id="editSchool" value={this.state.cursorTrainingSchool} type="text" onChange={(evt) => this.setState({ cursorTrainingSchool: evt.target.value })}/>
                                                    { this.state.validTrainingSchool ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                    <label htmlFor="editSchoolCountry">{this.props.t("profile.areas.qualification.areas.other-post-grad.school-country")} <span className="invalid-message">*</span></label>
                                                    <Dropdown id="editSchoolCountry" value={this.state.cursorTrainingCountry} options={WORLD_LIST} optionLabel="name" onChange={(evt) => this.setState({ cursorTrainingCountry: evt.value })}></Dropdown>
                                                    { this.state.validSchoolCountry ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                    <label htmlFor="editTrainingArea">{this.props.t("profile.areas.qualification.areas.other-post-grad.training-area")}</label>
                                                    <InputText id="editTrainingArea" value={this.state.cursorTrainingArea} type="text" onChange={(evt) => this.setState({ cursorTrainingArea: evt.target.value })}/>
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                    <label htmlFor="editRecognitionSchool">{this.props.t("profile.areas.qualification.areas.other-post-grad.recognition-school")} </label>
                                                    <InputText id="editRecognitionSchool" value={this.state.cursorAcceptanceSchool} type="text" onChange={(evt) => this.setState({ cursorAcceptanceSchool: evt.target.value })}/>
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                    <label htmlFor="editRecognitionDate">{this.props.t("profile.areas.qualification.areas.other-post-grad.recognition-date")} </label>
                                                    <Calendar value={this.state.cursorAcceptanceDate} dateFormat="dd/mm/yy" maxDate={new Date()} showIcon showButtonBar onChange={(evt) => this.setState({ cursorAcceptanceDate: evt.value })}/>
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                    <FileUpload mode="basic" 
                                                                accept="application/pdf" 
                                                                chooseLabel={this.props.t("profile.areas.qualification.areas.other-post-grad.upload-cert-hab")}
                                                                maxFileSize={1000000} 
                                                                uploadHandler={(evt) => this.uploadDocumentHandler(evt.files, 'cert_hab')} customUpload={true} auto={true}
                                                                onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                                                    {
                                                        this.state.certHabAttachment !== null ? 
                                                            <span>{this.state.certHabAttachmentName}</span> : null
                                                    }
                                                    { this.state.validCertHabFile ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                </div>
                                                <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                                    <FileUpload mode="basic" 
                                                                accept="application/pdf" 
                                                                chooseLabel={this.props.t("profile.areas.qualification.areas.other-post-grad.upload-cert-equiv")}
                                                                maxFileSize={1000000} 
                                                                uploadHandler={(evt) => this.uploadDocumentHandler(evt.files, 'cert_equiv')} customUpload={true} auto={true}
                                                                onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                                                    {
                                                        this.state.certEquivAttachment !== null ? 
                                                            <span>{this.state.certEquivAttachmentName}</span> : null
                                                    }
                                                </div>
                                                { this.state.validUploadFile ? null : <div className='col-12 t-align-left'><small className="p-error">{this.props.t("profile.areas.qualification.areas.other-post-grad.invalid-file")}</small></div>  }
                                            </div>
                                        </div>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                    <Toast position='bottom-left' ref={this._toast} />
                </div>
                : null
        );
    }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        registrationDocs: state.profile.registrationDocs,
        registrationRef: state.authentication.registrationRef,
        registrationApproved: state.authentication.registrationApproved,
        language: state.profile.language
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        setEditMode: (editMode) => { dispatch(setEditMode(editMode)) },
        getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(OtherPostGradDataComponent));